<template>
  <div class="vg-scan-qr-code">
    <vg-scan-qr-code
        ref="scan"
        class="vg-scan-qr-code-camara"
        v-bind:aspect-ratio="aspectRatio"
        @success-text="onSuccess"
        @error-message="onError"
    />
  </div>
</template>

<script>
import VgScanQrCode from "@/components/Commons/VgScanQrCode";
import {Toast} from "vant";

export default {
  name: "RichScan",
  components: {
    VgScanQrCode,
  },
  data() {
    return {
      aspectRatio: document.documentElement.clientHeight / document.documentElement.clientWidth,
    }
  },
  mounted() {
    // this.$refs.scan.getCameras();
  },
  methods: {
    onSuccess(value) {
      Toast.success("扫码成功: " + value);
      this.$router.replace({path:'/scanVerify/verifyRefer', query: {qrCode: value}});
    },
    onError(message) {
      console.log(message);

      // if (confirm(message)) {
      //   this.$router.push({path:'/scanVerify/verifyResult'});
      // }
    },
  },

}
</script>

<style scoped>
.vg-scan-qr-code {
  height: 100vh;
  height: calc(100vh - var(--vh-offset, 0px));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #000;
}

.vg-scan-qr-code-camara {
  width: 100vw;
}
</style>